import {
  consumePlayerService,
  featureToggleService,
  leaveGameService,
  saveRedirectUrlForLeaveGame,
  setApiAuthToken,
} from '@slot-nx/core'
import { gameConfig } from '../../config'
import { gameInfoService } from '../gameInfo'
export async function inGame() {
  const urlParams = new URLSearchParams(window.location.search)
  saveRedirectUrlForLeaveGame(urlParams)

  const authToken = await consumePlayerService.consumePlayer(
    urlParams.get('token'),
  )
  setApiAuthToken(authToken)
  leaveGameService.registerLeaveGameEvent()

  await Promise.all([
    featureToggleService.getFeatureToggleV2(),
    gameInfoService.getGameInfo(),
  ]).catch(console.error)

  window.history.replaceState({ path: '' }, '', `/${gameConfig.name}/index.html`)
}
